import React, { useState, useEffect, useRef } from "react";
import { supabase } from "../../supabaseClient";
import { motion, AnimatePresence } from "framer-motion";
import { toPng } from "html-to-image";
import GreenFieldImg from "../../Assets/Icons/green-field.jpg";
import FiledImg from "../../Assets/Icons/field.png";

const HomeBestTeam = ({ turnirId, turnirNaziv }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [timovi, setTimovi] = useState([]);
  const [igraciPoEkipi, setIgraciPoEkipi] = useState({});
  const [isSubmittedLocal, setIsSubmittedLocal] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [nazivTurnira, setNazivTurnira] = useState(turnirNaziv || "TURNIR");
  const [isLoaded, setIsLoaded] = useState(false);

  const [brojIgracaTeren, setBrojIgracaTeren] = useState(5);
  const [formacijaPozicije, setFormacijaPozicije] = useState([]);
  const [formacija, setFormacija] = useState({});

  const [activePozicija, setActivePozicija] = useState(null);
  const captureRef = useRef(null);

  useEffect(() => {
    if (turnirNaziv) {
      setNazivTurnira(turnirNaziv);
    }
  }, [turnirNaziv]);

  useEffect(() => {
    if (!turnirId) return;

    const fetchData = async () => {
      try {
        const { data: turnirData, error: turnirErr } = await supabase
          .from("admin_turniri")
          .select("naziv, broj_igraca")
          .eq("id", turnirId)
          .maybeSingle();

        if (!turnirErr && turnirData) {
          if (turnirData.naziv) setNazivTurnira(turnirData.naziv);
          const brIgraca = turnirData.broj_igraca
            ? parseInt(turnirData.broj_igraca)
            : 5;
          setBrojIgracaTeren(brIgraca);
          generirajPozicije(brIgraca);
        } else {
          setBrojIgracaTeren(5);
          generirajPozicije(5);
        }

        const { data: timoviData, error: timoviErr } = await supabase
          .from("turniri_timovi")
          .select("id, name, turnir_id, tournament_id, players")
          .or(`turnir_id.eq.${turnirId},tournament_id.eq.${turnirId}`);

        if (timoviErr) throw timoviErr;

        setTimovi(timoviData || []);

        const map = {};
        (timoviData || []).forEach((t) => {
          let parsedPlayers = [];
          try {
            parsedPlayers =
              typeof t.players === "string"
                ? JSON.parse(t.players)
                : t.players || [];
          } catch (e) {
            parsedPlayers = [];
          }
          map[t.name] = parsedPlayers;
        });
        setIgraciPoEkipi(map);
      } catch (err) {
        console.error("Greška kod dohvata podataka:", err);
      } finally {
        setIsLoaded(true);
      }
    };

    fetchData();
  }, [turnirId]);

  // Pametno generiranje pozicija s obzirom na broj igrača (točne formacije)
  const generirajPozicije = (broj) => {
    let pozicije = [];
    let initialFormacijaState = {};

    // Golman je uvijek tu
    pozicije.push({ id: "golman", label: "GOLMAN", className: "pos-gk" });
    initialFormacijaState["golman"] = { ekipa: "", igrac: "" };

    // Broj igrača u polju je (ukupni broj iz baze - 1 golman)
    const uPolju = broj - 1;

    if (uPolju === 2) {
      // 1 golman + 2 u polju (1 iza, 1 naprijed)
      pozicije.push({ id: "igrac_1", label: "OBRANA", className: "pos-3-1" });
      pozicije.push({ id: "igrac_2", label: "NAPAD", className: "pos-3-3" });
    } else if (uPolju === 3) {
      // 1 golman + 3 u polju (2 iza, 1 naprijed)
      pozicije.push({ id: "igrac_1", label: "OBRANA 1", className: "pos-3-1" });
      pozicije.push({ id: "igrac_2", label: "OBRANA 2", className: "pos-3-2" });
      pozicije.push({ id: "igrac_3", label: "NAPAD", className: "pos-3-3" });
    } else if (uPolju === 4) {
      // 1 golman + 4 u polju (1 iza, 2 u sredini, 1 špic)
      pozicije.push({ id: "igrac_1", label: "ZADNJI", className: "pos-4-1" });
      pozicije.push({
        id: "igrac_2",
        label: "VEZA LIJEVI",
        className: "pos-4-2",
      });
      pozicije.push({
        id: "igrac_3",
        label: "VEZA DESNI",
        className: "pos-4-3",
      });
      pozicije.push({ id: "igrac_4", label: "ŠPIC", className: "pos-4-4" });
    } else if (uPolju === 5) {
      // 1 golman + 5 u polju (Futsal: 1 iza, 2 u veznom, 2 u špicu)
      pozicije.push({ id: "igrac_1", label: "ZADNJI", className: "pos-5-1" });
      pozicije.push({
        id: "igrac_2",
        label: "VEZA LIJEVI",
        className: "pos-5-2",
      });
      pozicije.push({
        id: "igrac_3",
        label: "VEZA DESNI",
        className: "pos-5-3",
      });
      pozicije.push({
        id: "igrac_4",
        label: "ŠPIC LIJEVI",
        className: "pos-5-4",
      });
      pozicije.push({
        id: "igrac_5",
        label: "ŠPIC DESNI",
        className: "pos-5-5",
      });
    } else if (uPolju === 6) {
      // 1 golman + 6 u polju (1 iza, 3 u veznom, 2 u špicu)
      pozicije.push({ id: "igrac_1", label: "ZADNJI", className: "pos-6-1" });
      pozicije.push({
        id: "igrac_2",
        label: "VEZA LIJEVI",
        className: "pos-6-2",
      });
      pozicije.push({
        id: "igrac_3",
        label: "VEZA CENTAR",
        className: "pos-6-3",
      });
      pozicije.push({
        id: "igrac_4",
        label: "VEZA DESNI",
        className: "pos-6-4",
      });
      pozicije.push({
        id: "igrac_5",
        label: "ŠPIC LIJEVI",
        className: "pos-6-5",
      });
      pozicije.push({
        id: "igrac_6",
        label: "ŠPIC DESNI",
        className: "pos-6-6",
      });
    } else {
      // Dinamički fallback za ostale
      for (let i = 1; i <= uPolju; i++) {
        pozicije.push({
          id: `igrac_${i}`,
          label: `IGRAČ ${i}`,
          className: `pos-fallback-${i}`,
        });
      }
    }

    pozicije.forEach((p) => {
      initialFormacijaState[p.id] = { ekipa: "", igrac: "" };
    });

    setFormacijaPozicije(pozicije);
    setFormacija(initialFormacijaState);
  };

  const imaIgraca = timovi.some((t) => {
    try {
      const parsed =
        typeof t.players === "string" ? JSON.parse(t.players) : t.players;
      return Array.isArray(parsed) && parsed.length > 0;
    } catch (e) {
      return false;
    }
  });

  if (!isLoaded || timovi.length === 0 || !imaIgraca) {
    return null;
  }

  const handleSelectEkipa = (pozicija, ekipaNaziv) => {
    setFormacija((prev) => ({
      ...prev,
      [pozicija]: { ekipa: ekipaNaziv, igrac: "" },
    }));
  };

  const handleSelectIgrac = (pozicija, igracIme) => {
    setFormacija((prev) => ({
      ...prev,
      [pozicija]: { ...prev[pozicija], igrac: igracIme },
    }));
    setActivePozicija(null);
  };

  const isFormComplete =
    formacijaPozicije.length > 0 &&
    formacijaPozicije.every(
      (p) => formacija[p.id]?.ekipa && formacija[p.id]?.igrac,
    );

  const handleVoteAction = () => {
    if (!isFormComplete) {
      alert("Molimo popunite sve pozicije prije potvrde!");
      return;
    }
    setIsSubmittedLocal(true);
  };

  const handleDownloadInstagramImage = async () => {
    if (!captureRef.current || !isFormComplete) return;
    setDownloading(true);
    try {
      const dataUrl = await toPng(captureRef.current, {
        cacheBust: true,
        pixelRatio: 2,
        fontEmbedCSS: "",
        filter: (domNode) => {
          if (domNode.tagName === "LINK" || domNode.tagName === "I")
            return false;
          return true;
        },
      });
      const link = document.createElement("a");
      link.download = `idealnih-${brojIgracaTeren}-turnira.png`;
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error("Greška prilikom generiranja slike:", err);
      alert("Došlo je do greške prilikom stvaranja slike.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <button className="fantasy-floating-btn" onClick={() => setIsOpen(true)}>
        <img src={FiledImg} alt="Teren" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <div
            className="fantasy-modal-overlay"
            onClick={(e) => {
              if (e.target === e.currentTarget) setIsOpen(false);
            }}
          >
            <motion.div
              className="fantasy-modal-content"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
            >
              <button className="close-btn" onClick={() => setIsOpen(false)}>
                <i className="fa-solid fa-xmark"></i>
              </button>

              <div ref={captureRef} className="instagram-export-wrapper">
                <div className="instagram-header">
                  <div className="instagram-titles">
                    <h2>{nazivTurnira}</h2>
                    <span className="turnir-subname">
                      IDEALNA POSTAVA ({brojIgracaTeren})
                    </span>
                  </div>
                </div>

                <div
                  className="soccer-field-container"
                  style={{
                    backgroundImage: `url(${GreenFieldImg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  {formacijaPozicije.map((pos) => {
                    const odabraniIgrac = formacija[pos.id]?.igrac;
                    return (
                      <div
                        key={pos.id}
                        className={`field-slot ${pos.className}`}
                        onClick={() =>
                          !isSubmittedLocal && setActivePozicija(pos.id)
                        }
                      >
                        {odabraniIgrac ? (
                          <span className="player-name-tag">
                            {odabraniIgrac}
                          </span>
                        ) : (
                          <div className="slot-inner" title={pos.label}>
                            <i className="fi fi-br-plus"></i>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                <div className="instagram-footer">
                  <i className="fa-brands fa-instagram"></i>
                  <span>@fucascore</span>
                </div>
              </div>

              {isSubmittedLocal && (
                <div className="voted-message">
                  <i className="fa-solid fa-circle-check"></i>
                  <h4>Tvoja idealna postava je spremna!</h4>
                  <p>
                    Preuzmi sliku, stavi je na Instagram story i tagiraj turnir!
                  </p>
                </div>
              )}

              <div className="fantasy-actions-row">
                {!isSubmittedLocal && (
                  <button
                    className={`submit-fantasy-btn ${!isFormComplete ? "disabled" : ""}`}
                    onClick={handleVoteAction}
                    disabled={!isFormComplete}
                  >
                    Potvrdi postavu
                  </button>
                )}

                <button
                  className={`instagram-download-btn ${!isFormComplete ? "disabled" : ""}`}
                  onClick={handleDownloadInstagramImage}
                  disabled={downloading || !isFormComplete}
                >
                  <i className="fa-brands fa-instagram"></i>
                  {downloading ? "Generiranje..." : "Preuzmi za Instagram"}
                </button>
              </div>

              {activePozicija && (
                <div
                  className="sub-modal-overlay"
                  onClick={(e) => {
                    if (e.target === e.currentTarget) setActivePozicija(null);
                  }}
                >
                  <div className="sub-modal-box">
                    <h4>Odaberi igrača za poziciju</h4>

                    <div className="form-group">
                      <label>1. Odaberi ekipu:</label>
                      <select
                        value={formacija[activePozicija]?.ekipa || ""}
                        onChange={(e) =>
                          handleSelectEkipa(activePozicija, e.target.value)
                        }
                      >
                        <option value="">-- Izaberi ekipu --</option>
                        {timovi
                          .filter((t) => {
                            const igraci = igraciPoEkipi[t.name] || [];
                            return Array.isArray(igraci) && igraci.length > 0;
                          })
                          .map((t) => (
                            <option key={t.id} value={t.name}>
                              {t.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    {formacija[activePozicija]?.ekipa && (
                      <div className="form-group">
                        <label>2. Odaberi igrača:</label>
                        <select
                          value={formacija[activePozicija]?.igrac || ""}
                          onChange={(e) =>
                            handleSelectIgrac(activePozicija, e.target.value)
                          }
                        >
                          <option value="">-- Izaberi igrača --</option>
                          {(
                            igraciPoEkipi[formacija[activePozicija].ekipa] || []
                          ).map((igrac, idx) => (
                            <option
                              key={idx}
                              value={
                                typeof igrac === "string" ? igrac : igrac.name
                              }
                            >
                              {typeof igrac === "string" ? igrac : igrac.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <button
                      className="close-sub-btn"
                      onClick={() => setActivePozicija(null)}
                    >
                      Zatvori
                    </button>
                  </div>
                </div>
              )}
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </>
  );
};

export default HomeBestTeam;
